import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-products-erikois',
    templateUrl: './products-erikois.component.html',
    styleUrls: ['./products-erikois.component.css']
})
export class ProductsErikoisComponent implements OnInit {

    title = 'Special applications - Hitec';

    constructor(private titleService: Title) {
        titleService.setTitle(this.title);
    }

    ngOnInit(): void {
    }

}
